module.exports = __webpack_public_path__ + "3b4f74f7beb0e25e605a7fc2557466e8.pdf";